<template>
  <div>
    <v-data-table :headers="headers" :items="licitacionEventos">
      <template v-slot:[`item.eventoTexto`]="{ item }">
        <v-chip
        :color="getColorEvento(item)"
        dark>
          <span>{{item.eventoTexto}}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.fechaHora`]="{ item }">
        <span>
          {{ new Date(item.fechaHora).toLocaleDateString() }}
        </span>
      </template>
      <template v-slot:[`item.hora`]="{ item }">
        <span>
          {{ horaFormatoHrs(item.fechaHora) }}
        </span>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip
          v-if="mixValidaScopesActions(2)"
          top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="editarEventoLicitacion(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip
          v-if="mixValidaScopesActions(3)"
          top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="eliminarEventoLicitacion(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoEventosLicitacionDesktop',
  props: {
    licitacionEventos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Evento', align: 'start', value: 'eventoTexto',
        },
        { text: 'Fecha del Evento', align: 'center', value: 'fechaHora' },
        { text: 'Hora', align: 'center', value: 'hora' },
        {
          text: 'Lugar', align: 'start', value: 'lugar',
        },
        {
          text: '',
          value: 'acciones',
          align: 'end',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    horaFormatoHrs(fechaHora) {
      const fecha = new Date(fechaHora);
      const horas = fecha.getUTCHours().toString().length === 1 ? `0${fecha.getUTCHours()}` : fecha.getUTCHours();
      const minutos = fecha.getUTCMinutes().toString().length === 1 ? `0${fecha.getUTCMinutes()}` : fecha.getUTCMinutes();
      // const ampm = fecha.getUTCHours() >= 12 ? 'pm' : 'am';
      return `${horas}:${minutos} Hrs.`;
    },
    getColorEvento(evento) {
      if (evento.evento === 1) return '#1E88E5';
      if (evento.evento === 2) return '#673AB7';
      if (evento.evento === 3) return '#43BC82';
      return '#FA8B00';
    },
    editarEventoLicitacion(eventoLicitacion) {
      eventBus.$emit('editar-evento-licitacion', eventoLicitacion);
    },
    eliminarEventoLicitacion(eventoLicitacion) {
      eventBus.$emit('eliminar-evento-licitacion', eventoLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
